module.exports = __webpack_public_path__ + "img/img-97cc13.png";